import { connect } from 'react-redux';
import { fetchCategoriesIfNeeded, excludeDeprecated } from 'common/ducks/categories';
import { fetchSuggestedCreatives, selectCreative } from 'project/ducks/project_1_1';
import { fetchProfileIfNeeded } from 'profile/ducks/shared';
import Start1to1 from 'pap0/components/start_1_1';

Start1to1.need = [
  fetchCategoriesIfNeeded
]

const mapStateToProps = ({categories, project}, params) => {
  return {
    categories: excludeDeprecated(categories.data.filter((c) => c.is_one_to_one)),
    creative: project.projectPage.project1To1.selectedCreative,
    preselectedCreative: params.location.query.one_to_one_creative,
    preselectedSubcat: params.location.query.subcat,
  }
}

export default connect(mapStateToProps, {
  fetchCategoriesIfNeeded,
  fetchSuggestedCreatives,
  fetchProfileIfNeeded,
  selectCreative
})(Start1to1);



// WEBPACK FOOTER //
// ./pap0/containers/start_1_1.jsx